import {Component, Input } from '@angular/core';
import moment from 'moment';
import {PercentPipe} from '@angular/common';
import {isMoment, Moment} from 'moment';

@Component({
    selector: 'app-production-grid-quality',
    templateUrl: './production-grid-quality.component.html',
    styleUrls: ['./production-grid-quality.component.scss'],
    standalone: false
})
export class ProductionGridQualityComponent {
  @Input() selectedParksCount: number = 1;
  @Input() isForSummaryBlock: boolean = false;
  @Input() treatCurrentPeriodAsToday: boolean = false;
  @Input() type: string; // 'hours', 'days', 'months', 'days-ytd', 'months-ytd'
  @Input() value: number;
  @Input() period: Moment | string;

  private selectedPeriodAsMoment: Moment;


  constructor( public percentPipe: PercentPipe) { }

  public getProductionGridQualityDesiredValue() : number {
    if (!isMoment(this.period)) {
      this.selectedPeriodAsMoment = moment(this.period);
    } else {
      this.selectedPeriodAsMoment = this.period;
    }
    const result = this.selectedParksCount * this.getProductionGridQualityDesiredValueOnePark();
    return result;
  }

  private getProductionGridQualityDesiredValueOnePark() : number {
    switch (this.type) {
      case 'hours': {
        return this.isForSummaryBlock ? this.calcDays() : 1;
      }
      case 'days': {
        return this.isForSummaryBlock ? this.calcMonths() : this.calcDays();
      }
      case 'days-ytd': {
        return this.isForSummaryBlock ? this.calcMonths(true) : this.calcDays();
      }
      case 'months':
      case 'months_acc': {
        return this.isForSummaryBlock ? this.calcYears() : this.calcMonths();
      }
      case 'months-ytd': {
        return this.isForSummaryBlock ? this.calcYears(true) : this.calcMonths(true);
      }
      default:
        return -1;
    }
  }

  private calcDays() :number {
    const isToday = moment().isSame(moment(this.period), 'd');
    if (isToday) {
      return moment().hour();
    }
    else {
      const startOfDay = this.selectedPeriodAsMoment.clone().startOf('day');
      const endOfDay = this.selectedPeriodAsMoment.clone().endOf('day');
      const duration = moment.duration(endOfDay.diff(startOfDay));
      const res = Math.floor(Number(duration.asHours().toFixed(2)));
      return  res
    }
  }


  private calcMonths(periodToDate = false): number {

    const startOfMonth = this.selectedPeriodAsMoment.clone().startOf('day').startOf('month');
    let hoursSinceStartOfMonth = -1;
    const isToday = moment().isSame(this.selectedPeriodAsMoment, this.treatCurrentPeriodAsToday? 'M' : 'd');
    if (periodToDate || isToday) {
      const lastDayOfMonth = (isToday ? moment() : this.selectedPeriodAsMoment.clone().endOf('day'));
      const duration = moment.duration(lastDayOfMonth.diff(startOfMonth));
      hoursSinceStartOfMonth = Math.floor(Number(duration.asHours().toFixed(2)));
    }
    else {
      const endOfMonth = this.selectedPeriodAsMoment.clone().endOf('month');
      const duration = moment.duration(endOfMonth.diff(startOfMonth));
      hoursSinceStartOfMonth = Math.floor(Number(duration.asHours().toFixed(2)));
    }
    return hoursSinceStartOfMonth;
  }

  private calcYears(periodToDate = false): number {
    const startOfYear = this.selectedPeriodAsMoment.clone().startOf('day').startOf('year');
    const isToday = moment().isSame(this.selectedPeriodAsMoment, this.treatCurrentPeriodAsToday? 'y' : 'd');
    if (periodToDate || isToday) {
      const lastDayOfYear = (isToday ? moment() : this.selectedPeriodAsMoment.clone().endOf('day'));
      const duration = moment.duration(lastDayOfYear.diff(startOfYear));
      const hoursSinceBeginningOfYear = Math.floor(Number(duration.asHours().toFixed(2)));
      return hoursSinceBeginningOfYear;
    }
    else {
      const endOfYear = this.selectedPeriodAsMoment.clone().endOf('year');
      const duration = moment.duration(endOfYear.diff(startOfYear));
      return Math.floor(Number(duration.asHours().toFixed(2)));
    }
  }


}
